import { store } from "global";
import type { AudioInputItemPlayQueueModel } from "models/app/player/input";

export function getQueueTrackFromAudio(audio: AudioInputItemPlayQueueModel) {
    const tracks = store.getState().queue.playQueue;
    const track = tracks.find((track) => track.queueId === audio.queueId);

    return track ?? null;
}
